import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Owned } from 'app/model/base/named';
import { Pipeline } from 'shell-models-lib';

@Metamodel.model({})
export class VariablesConfig extends Owned {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;

    public name: string = '';

    @Metamodel.attribute({
        templatable: true,
        accepts: ['Any'],
        association: 'VALUE'
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public value: any = {};

    public get type(): string {
        if (this._type === undefined) {
            this._loadVariableType();
        }

        return this._type;
    }

    // eslint-disable-next-line
    public set type(varType: string) {
        this._type = varType;
    }

    private _type: string;

    private _loadVariableType(): void {
        const pipeline = this.rootOwner as Pipeline;
        const variable = pipeline.variables?.find((v) => v.name === this.name);
        this._type = variable ? variable._type : '';
    }
}
